import { jsx as _jsx } from "react/jsx-runtime";
import PageSection from '~components/page-section';
import { useEffect } from 'react';
import { exchangeRateService } from '~service';
import { logEvent } from '@phishtool/analytics';
import { ProductComparison } from '@phishtool/products';
const PricingSection = ({ community, professional, enterprise }) => {
    useEffect(() => {
        logEvent('Pricing Viewed', { variant: 'standard' });
    }, []);
    return (_jsx(PageSection, { id: "pricing", title: "Pricing", headerSpacer: ['x3', null, 'x6'], hasDivider: false, children: _jsx(ProductComparison, { size: "large", community: community, professional: professional, enterprise: enterprise, useGetExchangeRates: exchangeRateService.useGetExchangeRates }) }));
};
export default PricingSection;
